<template>
  <div class="ibox ">
    <div class="ibox-title">
      <div class="ibox-tools">
          <span :class="['label float-right', declaration.tag.class]">{{ declaration.tag.title }}</span>
      </div>
      <h5>{{ declaration.title }}</h5>
    </div>
    <div class="ibox-content">
      <h1 class="no-margins">{{ declaration.amount }}</h1>
      <div class="stat-percent font-bold text-success">{{ declaration.percent }}% <i :class="declaration.icon"></i></div>
      <small>{{declaration.description}}</small>
    </div>
  </div>
</template>
<script>

export default {
    data() {
        return {
            
        }
    },
    props:{
        declaration:{
            type: Object
        }
    },

    created(){

    },
    methods:{
     
    }
}

</script>